(function () {
  'use strict';

  function initMobilePDPZoom() {

    if (window.innerWidth > 767) return;

    const gallery = document.querySelector('.tt-mobile-product-slider');

    if (!gallery) {
      return;
    }

    /*
     * Don't initialize the same gallery multiple times
     */
    if (gallery.dataset.mobileZoomReady === 'true') {
      return;
    }

    gallery.dataset.mobileZoomReady = 'true';

    /*
     * Get all actual Slick slides.
     * Exclude cloned slides.
     */
    function getSlides() {
      return Array.from(
        gallery.querySelectorAll('.slick-slide:not(.slick-cloned)')
      );
    }

    function getImages() {
      return getSlides()
        .map(slide => slide.querySelector('img'))
        .filter(Boolean);
    }

    /*
     * Add zoom buttons
     */
    function addZoomButtons() {

      const slides = getSlides();

      slides.forEach(function (slide, index) {

        if (!slide.querySelector('.mobile-pdp-zoom-btn')) {

          const button = document.createElement('button');

          button.type = 'button';
          button.className = 'mobile-pdp-zoom-btn';

          button.setAttribute(
            'aria-label',
            'Zoom product image ' + (index + 1)
          );

          button.innerHTML = `
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true">

              <circle cx="10.8" cy="10.8" r="6.8"></circle>

              <path d="M16 16l5 5"></path>

              <path d="M10.8 7.8v6"></path>

              <path d="M7.8 10.8h6"></path>

            </svg>
          `;

          slide.appendChild(button);
        }

      });

    }

    /*
     * Slick may modify the slides after initialization.
     * Run once immediately and again shortly after.
     */
    addZoomButtons();

    setTimeout(addZoomButtons, 500);
    setTimeout(addZoomButtons, 1200);


    /*
     * Create zoom modal
     */
    let modal = document.querySelector('.mobile-pdp-zoom-modal');

    if (!modal) {

      modal = document.createElement('div');

      modal.className = 'mobile-pdp-zoom-modal';

      modal.innerHTML = `

        <div class="mobile-pdp-zoom-header">

          <div class="mobile-pdp-zoom-counter">
            <span class="zoom-current">1</span>
            /
            <span class="zoom-total">1</span>
          </div>

          <button
            type="button"
            class="mobile-pdp-zoom-close"
            aria-label="Close image zoom">

            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round">

              <path d="M6 6l12 12"></path>
              <path d="M18 6L6 18"></path>

            </svg>

          </button>

        </div>


        <button
          type="button"
          class="mobile-pdp-zoom-prev"
          aria-label="Previous image">

          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round">

            <path d="M15 18l-6-6 6-6"></path>

          </svg>

        </button>


        <div class="mobile-pdp-zoom-stage">

          <img
            class="mobile-pdp-zoom-image"
            alt=""
            draggable="false">

        </div>


        <button type="button" class="mobile-pdp-zoom-next" aria-label="Next image">
            <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true">
                
                <path d="M9 6l6 6-6 6"></path>

            </svg>
        </button>

      `;

      document.body.appendChild(modal);
    }


    const zoomImage =
      modal.querySelector('.mobile-pdp-zoom-image');

    const stage =
      modal.querySelector('.mobile-pdp-zoom-stage');

    const closeButton =
      modal.querySelector('.mobile-pdp-zoom-close');

    const prevButton =
      modal.querySelector('.mobile-pdp-zoom-prev');

    const nextButton =
      modal.querySelector('.mobile-pdp-zoom-next');

    const currentCounter =
      modal.querySelector('.zoom-current');

    const totalCounter =
      modal.querySelector('.zoom-total');


    let currentIndex = 0;

    let scale = 1;

    let translateX = 0;
    let translateY = 0;

    let startX = 0;
    let startY = 0;

    let startDistance = 0;
    let startScale = 1;

    let dragging = false;

    let lastTap = 0;


    /*
     * Get high resolution Shopify image
     */
    function getHighResolutionImage(url) {

      if (!url) return '';

      /*
       * Example:
       * image_1024x1024.jpg
       *
       * becomes:
       * image.jpg
       */

      return url.replace(
        /_\d+x\d+(?=\.[a-z0-9]+(?:\?|$))/i,
        ''
      );
    }


    function updateTransform() {

      zoomImage.style.transform =
        'translate3d(' +
        translateX +
        'px,' +
        translateY +
        'px,0) scale(' +
        scale +
        ')';

    }


    function resetZoom() {

      scale = 1;

      translateX = 0;
      translateY = 0;

      updateTransform();

    }


    function loadZoomImage(index) {

      const images = getImages();

      if (!images.length) return;

      if (index < 0) {
        index = images.length - 1;
      }

      if (index >= images.length) {
        index = 0;
      }

      currentIndex = index;

      const source = images[currentIndex];

      let imageURL =
        source.getAttribute('data-original') ||
        source.getAttribute('data-src') ||
        source.currentSrc ||
        source.src;

      imageURL = getHighResolutionImage(imageURL);

      zoomImage.src = imageURL;

      zoomImage.alt =
        source.alt || 'Product image';

      currentCounter.textContent =
        currentIndex + 1;

      totalCounter.textContent =
        images.length;

      resetZoom();

    }


    function openZoom(index) {

      loadZoomImage(index);

      modal.classList.add('is-active');

      document.documentElement.classList.add(
        'mobile-pdp-zoom-open'
      );

      document.body.classList.add(
        'mobile-pdp-zoom-open'
      );

    }


    function closeZoom() {

      modal.classList.remove('is-active');

      document.documentElement.classList.remove(
        'mobile-pdp-zoom-open'
      );

      document.body.classList.remove(
        'mobile-pdp-zoom-open'
      );

      resetZoom();

    }


    /*
     * IMPORTANT:
     *
     * Event delegation.
     *
     * This means the button can be added
     * after Slick initializes and it will
     * still work.
     */
    gallery.addEventListener('click', function (event) {

      const button =
        event.target.closest('.mobile-pdp-zoom-btn');

      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      const slide =
        button.closest('.slick-slide');

      if (!slide) return;

      const index =
        parseInt(
          slide.getAttribute('data-slick-index'),
          10
        );

      if (!isNaN(index)) {
        openZoom(index);
      }

    });


    /*
     * Close
     */
    closeButton.addEventListener(
      'click',
      closeZoom
    );


    /*
     * Previous
     */
    prevButton.addEventListener(
      'click',
      function () {

        loadZoomImage(
          currentIndex - 1
        );

      }
    );


    /*
     * Next
     */
    nextButton.addEventListener(
      'click',
      function () {

        loadZoomImage(
          currentIndex + 1
        );

      }
    );


    /*
     * Double tap zoom
     */
    stage.addEventListener(
      'touchend',
      function (event) {

        if (event.touches.length) return;

        const now = Date.now();

        if (now - lastTap < 300) {

          event.preventDefault();

          if (scale > 1) {

            resetZoom();

          } else {

            scale = 2.5;

            updateTransform();

          }

        }

        lastTap = now;

      },
      { passive: false }
    );


    /*
     * Touch start
     */
    stage.addEventListener(
      'touchstart',
      function (event) {

        if (event.touches.length === 2) {

          event.preventDefault();

          startDistance =
            getDistance(
              event.touches[0],
              event.touches[1]
            );

          startScale = scale;

          return;
        }

        if (
          event.touches.length === 1 &&
          scale > 1
        ) {

          dragging = true;

          startX =
            event.touches[0].clientX -
            translateX;

          startY =
            event.touches[0].clientY -
            translateY;

        }

      },
      { passive: false }
    );


    /*
     * Pinch + drag
     */
    stage.addEventListener(
      'touchmove',
      function (event) {

        /*
         * PINCH
         */
        if (event.touches.length === 2) {

          event.preventDefault();

          const distance =
            getDistance(
              event.touches[0],
              event.touches[1]
            );

          if (!startDistance) return;

          scale =
            startScale *
            (distance / startDistance);

          scale = Math.max(
            1,
            Math.min(scale, 4)
          );

          updateTransform();

          return;
        }


        /*
         * DRAG
         */
        if (
          event.touches.length === 1 &&
          dragging &&
          scale > 1
        ) {

          event.preventDefault();

          translateX =
            event.touches[0].clientX -
            startX;

          translateY =
            event.touches[0].clientY -
            startY;

          updateTransform();

        }

      },
      { passive: false }
    );


    stage.addEventListener(
      'touchend',
      function () {

        dragging = false;

        startDistance = 0;

        if (scale <= 1.02) {
          resetZoom();
        }

      }
    );


    function getDistance(a, b) {

      const x =
        a.clientX - b.clientX;

      const y =
        a.clientY - b.clientY;

      return Math.sqrt(
        x * x + y * y
      );

    }


    /*
     * ESC
     */
    document.addEventListener(
      'keydown',
      function (event) {

        if (!modal.classList.contains('is-active')) {
          return;
        }

        if (event.key === 'Escape') {
          closeZoom();
        }

        if (event.key === 'ArrowLeft') {
          loadZoomImage(currentIndex - 1);
        }

        if (event.key === 'ArrowRight') {
          loadZoomImage(currentIndex + 1);
        }

      }
    );


    /*
     * Re-add buttons if Slick rebuilds gallery
     */
    const observer =
      new MutationObserver(function () {

        addZoomButtons();

      });

    observer.observe(
      gallery,
      {
        childList: true,
        subtree: true
      }
    );

  }


  /*
   * Wait until Shopify/Slick has created
   * the mobile gallery.
   */
  function boot() {

    if (window.innerWidth > 767) return;

    let attempts = 0;

    const timer = setInterval(function () {

      const gallery =
        document.querySelector(
          '.tt-mobile-product-slider'
        );

      const images =
        gallery
          ? gallery.querySelectorAll(
              '.slick-slide img'
            )
          : [];

      attempts++;

      if (
        gallery &&
        images.length
      ) {

        clearInterval(timer);

        initMobilePDPZoom();

      }

      /*
       * Don't keep checking forever
       */
      if (attempts > 30) {
        clearInterval(timer);
      }

    }, 200);

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      boot
    );

  } else {

    boot();

  }


  /*
   * Shopify section reload
   */
  document.addEventListener(
    'shopify:section:load',
    function () {

      setTimeout(
        boot,
        500
      );

    }
  );

})();